<template>
    <div>
        <b-row class="mb-3">
            <b-col><span class="h3">Fulfillment Centers</span></b-col>
        </b-row>
        <b-card header-bg-variant="dark">
            <template v-slot:header>
                <b-form-row>
                    <b-col>
                        <span class="h5 mb-0">Destination States</span>
                    </b-col>
                    <b-col cols="8" class="text-right">
                        <span class="text-right" v-if="isEditing">
                            <label for="select-presets" class="text-white mr-2">Presets:</label>
                            <b-form-select size="sm" style="max-width: 200px;" v-model="selectedPreset" :options="presets" id="select-presets"></b-form-select>
                            <b-button size="sm"
                                      v-b-tooltip.hover
                                      title="Cancel changes"
                                      variant="secondary"
                                      class="ml-2"
                                      :disabled="isSaving"
                                      @click="cancelEdits">Cancel <i class="ml-1 fa-regular fa-times"></i>
                            </b-button>
                            <b-button size="sm"
                                      variant="success"
                                      class="ml-2"
                                      v-b-tooltip.hover
                                      title="Save changes"
                                      :disabled="isSaving"
                                      @click="saveEdits">Save
                                <i v-if="!isSaving" class="ml-1 fa-regular fa-check"></i>
                                <i v-else class="fa-regular fa-spin fa-spinner"></i>
                            </b-button>
                        </span>
                        <b-button class="ml-2" size="sm"
                                  :disabled="isEditing || isLoading || isSaving"
                                  @click="isEditing = !isEditing"
                                  variant="outline-secondary"><i class="fal fa-edit"></i>
                        </b-button>
                    </b-col>
                </b-form-row>
            </template>

            <template v-if="!isEditing">

                <!--view table-->
                <b-table small
                         bordered
                         striped
                         head-variant="light"
                         class="text-center mb-0"
                         :busy="isLoading"
                         :items="fulfillment_centers"
                         :fields="['destination_state', 'fulfillment_center']">
                    <template v-slot:cell(fulfillment_center)="data">
                        <i class="fas fa-location-dot fa-fw text-info" v-if="data.value === 'florida'"></i>
                        <i class="fas fa-location-dot fa-fw text-warning" v-if="data.value === 'kansas'"></i>
                        {{ data.value | titleCase }}
                    </template>
                    <template v-slot:table-busy>
                        <LoadingSpinner :busy="isLoading"></LoadingSpinner>
                    </template>
                </b-table>
            </template>

            <!-- EDITS -->
            <template v-else>

                <!--edit table-->
                <b-table small
                         bordered
                         striped
                         head-variant="light"
                         class="text-center mb-0"
                         :items="fulfillment_centers"
                         :fields="['destination_state', 'fulfillment_center']">
                    <template v-slot:cell(fulfillment_center)="data">
                        <b-input-group size="sm">
                            <b-input-group-prepend>
                                <i class="fas fa-location-dot fa-fw text-info m-2" v-if="data.value === 'florida'"></i>
                                <i class="fas fa-location-dot fa-fw text-warning m-2" v-if="data.value === 'kansas'"></i>
                            </b-input-group-prepend>
                            <b-form-select :options="fulfillmentCenterOptions" v-model="data.item.fulfillment_center"
                                           size="sm"
                                           :disabled="isSaving"></b-form-select>
                        </b-input-group>
                    </template>

                </b-table>


                <!-- save/cancel -->
                <b-card body-class="mb-0 p-2" class="mb-0" bg-variant="light">
                    <div class="text-right">
                        <b-button size="sm"
                                  v-b-tooltip.hover
                                  title="Cancel changes"
                                  variant="secondary"
                                  :disabled="isSaving"
                                  @click="cancelEdits">Cancel <i class="ml-1 fa-regular fa-times"></i>
                        </b-button>
                        <b-button size="sm"
                                  variant="success"
                                  class="ml-2"
                                  v-b-tooltip.hover
                                  title="Save changes"
                                  :disabled="isSaving"
                                  @click="saveEdits">Save
                            <i v-if="!isSaving" class="ml-1 fa-regular fa-check"></i>
                            <i v-else class="fa-regular fa-spin fa-spinner"></i>
                        </b-button>
                    </div>
                </b-card>


            </template>

        </b-card>


    </div>
</template>

<script>
import _ from 'lodash';
import LoadingSpinner from '@/components/LoadingSpinner';

export default {
    name: 'fulfillment-centers-view',
    components: {
        LoadingSpinner
    },
    data() {
        return {
            isLoading: false,
            isEditing: false,
            isSaving: false,
            fulfillment_centers: [],
            fulfillment_centers_cache: [],
            fulfillmentCenterOptions: [
                {value: 'florida', text: 'Florida'},
                {value: 'kansas', text: 'Kansas'},
            ],
            presets: [
                {text: 'Select Preset', disabled: true, value: null, },
                {text: 'Monday', value: 'presetMonday'},
                {text: 'Tues-Wed', value: 'presetTuesWed'},
                {text: 'All Florida', value: 'presetAllFlorida'},
                {text: 'Mayday', value: 'presetMayday'},
                {text: 'Extreme Mayday', value: 'presetExtremeMayday'},
            ],
            selectedPreset: null,
            presetMonday: [
                {
                    destination_state: 'AK',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'AL',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'AR',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'AZ',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'CA',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'CO',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'CT',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'DC',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'DE',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'FL',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'GA',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'HI',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'IA',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'ID',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'IL',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'IN',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'KS',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'KY',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'LA',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'MA',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'MD',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'ME',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'MI',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'MN',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'MO',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'MS',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'MT',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'NC',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'ND',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'NE',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'NH',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'NJ',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'NM',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'NV',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'NY',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'OH',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'OK',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'OR',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'PA',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'PR',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'RI',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'SC',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'SD',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'TN',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'TX',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'UT',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'VA',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'VT',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'WA',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'WI',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'WV',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'WY',
                    fulfillment_center: 'florida',
                },
            ],
            presetTuesWed: [
                {
                    destination_state: 'AK',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'AL',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'AR',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'AZ',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'CA',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'CO',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'CT',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'DC',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'DE',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'FL',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'GA',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'HI',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'IA',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'ID',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'IL',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'IN',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'KS',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'KY',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'LA',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'MA',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'MD',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'ME',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'MI',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'MN',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'MO',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'MS',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'MT',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'NC',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'ND',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'NE',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'NH',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'NJ',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'NM',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'NV',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'NY',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'OH',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'OK',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'OR',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'PA',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'PR',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'RI',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'SC',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'SD',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'TN',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'TX',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'UT',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'VA',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'VT',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'WA',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'WI',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'WV',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'WY',
                    fulfillment_center: 'florida',
                },
            ],
            presetMayday: [
                {
                    destination_state: 'AK',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'AL',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'AR',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'AZ',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'CA',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'CO',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'CT',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'DC',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'DE',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'FL',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'GA',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'HI',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'IA',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'ID',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'IL',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'IN',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'KS',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'KY',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'LA',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'MA',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'MD',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'ME',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'MI',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'MN',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'MO',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'MS',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'MT',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'NC',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'ND',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'NE',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'NH',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'NJ',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'NM',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'NV',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'NY',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'OH',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'OK',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'OR',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'PA',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'PR',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'RI',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'SC',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'SD',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'TN',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'TX',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'UT',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'VA',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'VT',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'WA',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'WI',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'WV',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'WY',
                    fulfillment_center: 'kansas',
                },
            ],
            presetExtremeMayday: [
                {
                    destination_state: 'AK',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'AL',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'AR',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'AZ',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'CA',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'CO',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'CT',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'DC',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'DE',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'FL',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'GA',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'HI',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'IA',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'ID',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'IL',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'IN',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'KS',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'KY',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'LA',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'MA',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'MD',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'ME',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'MI',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'MN',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'MO',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'MS',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'MT',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'NC',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'ND',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'NE',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'NH',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'NJ',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'NM',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'NV',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'NY',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'OH',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'OK',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'OR',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'PA',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'PR',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'RI',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'SC',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'SD',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'TN',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'TX',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'UT',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'VA',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'VT',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'WA',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'WI',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'WV',
                    fulfillment_center: 'kansas',
                },
                {
                    destination_state: 'WY',
                    fulfillment_center: 'kansas',
                },
            ],
            presetAllFlorida: [
                {
                    destination_state: 'AK',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'AL',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'AR',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'AZ',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'CA',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'CO',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'CT',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'DC',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'DE',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'FL',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'GA',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'HI',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'IA',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'ID',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'IL',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'IN',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'KS',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'KY',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'LA',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'MA',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'MD',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'ME',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'MI',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'MN',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'MO',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'MS',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'MT',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'NC',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'ND',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'NE',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'NH',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'NJ',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'NM',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'NV',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'NY',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'OH',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'OK',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'OR',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'PA',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'PR',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'RI',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'SC',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'SD',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'TN',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'TX',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'UT',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'VA',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'VT',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'WA',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'WI',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'WV',
                    fulfillment_center: 'florida',
                },
                {
                    destination_state: 'WY',
                    fulfillment_center: 'florida',
                },
            ],
        };
    },
    created() {
        this.getAllData();
    },
    watch: {
        selectedPreset: {
            handler(val){
                    console.log(val);
                    // assign(this.fulfillment_centers, this[val]);
                    this.fulfillment_centers = _.cloneDeep(this[val]);
                }
        }
    },
    methods: {
        getAllData() {
            this.isLoading = true;
            this.$http.get('/fulfillment-centers').then(response => {
                this.fulfillment_centers = response.data.data;
                this.fulfillment_centers_cache = _.cloneDeep(this.fulfillment_centers);
                this.isLoading = false;
            });
        },

        cancelEdits() {
            this.fulfillment_centers = _.cloneDeep(this.fulfillment_centers_cache);
            this.isEditing = false;
        },

        saveEdits() {
            this.isSaving = true;
            this.$http.put('/fulfillment-centers/updateAll', {fulfillment_centers: this.fulfillment_centers})
                .then(response => {
                    this.fulfillment_centers = response.data.data;
                    this.fulfillment_centers_cache = _.cloneDeep(this.fulfillment_centers);
                    this.$nextTick(() => {
                        this.isSaving = false;
                        this.isEditing = false;
                    });
                });
        },

    },
};
</script>

<style scoped>

</style>
